import { FormBase } from 'core/components';
import validatorjs from 'validatorjs';

export default class MarkAsShippedForm extends FormBase {
	constructor(hooks) {
		super(hooks);

		this.Validator = validatorjs;
		this.Validator.register(
			'decimalLength',
			value => {
				var decimal = value.toString().split('.')[1];
				if (decimal) {
					return decimal.length <= 2;
				}
				return true;
			},
			'MINIMUMLENGHT'
		);
		this.Validator.register(
			'numericMinValue',
			value => {
				return 1 / value > 0;
			},
			'NUMERICMINVALUE'
		);
	}
	setup() {
		return {
			fields: [
				{
					name: 'warehouse',
					label: 'FULFILLMENTORDER.MARKASSHIPPEDMODAL.WAREHOUSE',
					rules: 'required',
				},
				{
					name: 'trackingNumber',
					label: 'FULFILLMENTORDER.MARKASSHIPPEDMODAL.TRACKINGNUMBER',
					rules: 'required',
				},
				{
					name: 'carrierService',
					label: 'CHANGESHIPPINGVIEW.CARRIERSERVICE',
					rules: 'required',
				},
				{
					name: 'cost',
					label: 'FULFILLMENTORDER.MARKASSHIPPEDMODAL.COST',
					rules: 'required|numeric|decimalLength|numericMinValue',
				},
				{
					name: 'shippingCostSurcharge',
					label: 'FULFILLMENTORDER.MARKASSHIPPEDMODAL.SURPLUSCHARGE',
					rules: 'numeric|decimalLength|numericMinValue',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/MarkAsShippedForm.js